<template>
    <el-container>
    <el-header style="height: 120px;">
      <div class="all-search">
      <div class="addcss" >
        <el-button type="primary"   @click="addUser">增加</el-button>
      </div>
      </div>
    </el-header>
<!--      style="width: auto"-->
    <el-main style="line-height:50px;">
      <div class="tabledata">
        <el-table :data="users"  ref="multipleTable"  highlight-selection-row  @selection-change="handleSelect"  style="width: auto;">
          <el-table-column
            type="index"
            width="50"
            label="序号">
          </el-table-column>
        <el-table-column prop="username" label="用户名">
        </el-table-column>
        <el-table-column prop="role" label="角色" >
        </el-table-column>
        <el-table-column  label="操作"  >
          <template slot-scope="scope">
          <el-link  @click="deleteUser(scope.row.id,scope.row.username)">删除</el-link>
          </template>
        </el-table-column>

      </el-table>
      </div>
    </el-main>
    <el-footer><el-pagination background layout="sizes,total,prev, pager, next"  :page-sizes="[10, 15, 20, 25]"  :page-size="this.queryInfo.pageSize"  @size-change="handleSizeChange"  @current-change="changePage" :total="this.total" :current-page="this.queryInfo.pageNum">
    </el-pagination></el-footer>
    </el-container>
</template>

<script>
// import router from '../../router/index'
import axios from '../../../utils/request'
export default {
  data () {
    return {
      users: [],
      queryInfo: {
        pageSize: 10,
        pageNum: 1
      }
      // statusFilter: ''
    }
  },

  // components: {
  //   table
  // },
  created: function () {
    this.methodToTrigger()
    console.log(this.users)
  },
  methods: {
    methodToTrigger: function () {
      axios.get(`/user/getusers?pageNum=${this.queryInfo.pageNum}&pageSize=${this.queryInfo.pageSize}`).then(res => {
        this.users = res.data.list
        this.total = res.data.total
      }).catch(error => {
        console.log('error', error)
      })
    },
    changePage: function (val) {
      var that = this
      this.queryInfo.pageNum = val
      axios
        .get(`/user/getusers?pageNum=${this.queryInfo.pageNum}&pageSize=${this.queryInfo.pageSize}`)
        .then(function (res) {
          that.users = res.data.list
          that.total = res.data.total
        }).catch(error => {
          console.log('111111', error)
        })
    },
    deleteUser: function (val, val2) {
      var that = this
      that.$confirm('删除该条记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        axios.delete(`/user/deluser?id=${val}&username=${val2}`)
          .then(function (res) {
            console.log('resuser', res)
            if (res.code === 200) {
              that.$message({
                type: 'success',
                message: '删除成功!'
              })
              that.methodToTrigger()
            } else if (res.code === 500) {
              that.$message({
                type: 'info',
                message: res.message
              })
            }
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            })
          })
      })
    },
    addUser () {
      this.$router.push('/data/adduser')
    }
  }
}
</script>

<style scoped >
  .el-container {
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:258px;
    height: 100%;
  }
  .el-header{
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 60px;
    padding:0;
  }
  .el-footer {
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 60px;
    height: 60px;
    padding:0;
  }

  .el-main {
    margin: 0px -43px;
    /*background-color: #B3C0D1;*/
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  .addcss {
    float: right;
    margin-right: 10px;
  }
  .tabledata {
    height:70vh;
    margin-left: 20px;
  }

  .search-input{
    float:left;
    margin-left: 10px;
  }
  .search-button{
    float:left;
    margin-left: 10px;
  }
  .search-reset{
    float:left;
    margin-left: 10px;
  }
  .all-search{
    overflow: hidden;
    margin-left: -16px;
  }
  /* 新增：用于定位下拉框，使其独占一行 */
  .status-filter-select {
    float: left; /* 和按钮一样靠右 */
    margin-right: 10px;
    margin-top: 5px; /* 添加一些上边距，使其在按钮下方 */
  }
</style>



// WEBPACK FOOTER //
// src/components/table/user/user.vue